<template>
  <div>
    <!-- LOGIN -->
    <!-- logo white -->
    <div
      class="d-flex flex-column-auto flex-column pt-lg-10 pt-10"
      v-if="place == 'login-white'"
    >
      <a
        href="#"
        class="text-center mb-3"
      >
        <img
          src="/images/logo-medhop-transparent.png"
          class="max-h-150px"
          alt=""
        />
      </a>
    </div>
    <!-- end logo white -->

    <!-- logo -->
    <div
      class="pb-13 pt-lg-0 pt-5 d-flex justify-content-center"
      v-if="place == 'login'"
    >
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        width="280"
        max-height="150"
        alt=""
      />
    </div>
    <!-- end logo -->
    <!-- end LOGIN -->

    <!-- Print Medical Record -->
    <template v-if="place == 'print-medical-record'">
      <img :src="data.logo || '/images/logo-medhop-transparent.png'" width="300" class="mt-8" alt="Logo" />
    </template>

    <!-- General -->
    <!-- brand logo -->
    <div
      class="brand-logo medhop-sidebar-logo"
      v-if="place == 'brand'"
    >
      <div class="medhop-sidebar-logo__content">
        <router-link to="/">
          <img
            :src="brandLogo"
            alt="Logo klinik"
            @error="useMedhopLogo"
          />
          <small>Powered by Medhop</small>
        </router-link>
        <button
          v-if="canEditDefaultBrandLogo"
          type="button"
          class="medhop-sidebar-logo__edit"
          :disabled="uploadingBrandLogo"
          :aria-label="uploadingBrandLogo ? 'Sedang mengunggah logo' : 'Ganti logo klinik'"
          v-b-tooltip.hover
          title="Ganti logo klinik"
          @click="openBrandLogoPicker"
        >
          <i
            :class="uploadingBrandLogo ? 'fas fa-spinner fa-spin' : 'fas fa-pencil-alt'"
            aria-hidden="true"
          ></i>
        </button>
        <input
          ref="brandLogoInput"
          class="medhop-sidebar-logo__input"
          type="file"
          accept=".jpg,.jpeg,.png,.svg"
          @change="uploadBrandLogo"
        >
      </div>
    </div>
    <!-- end brand logo -->
    <!-- end General -->

    <!-- print out section -->
    <!-- medical record -->
    <div
      class="col-md-12 d-flex justify-content-center"
      v-if="place == 'logo-themplate'"
    >
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        width="300"
        class="mt-8"
        alt="Logo"
      />
    </div>
    <!-- end medical record -->

    <!-- invoice -->
    <div class="d-flex justify-content-center">
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        height="60"
        style="margin-left: -10px"
        v-if="place == 'logo-invoice'"
      />
    </div>
    <!-- end invoice -->

    <!-- invoice thermal print-->
    <div class="d-flex justify-content-center">
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        height="130"
        style="margin-left: -10px"
        v-if="place == 'logo-invoice-thermal-print'"
      />
    </div>
    <!-- end invoice -->

    <!-- po invoice -->
    <div
      class="d-flex justify-content-end logo-po"
      v-if="place == 'logo-po'"
    >
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        width="200"
      />
    </div>
    
    <!-- end po invoice -->

    <!-- logo default Medhop -->
    <div
      class="d-flex justify-content-end"
      v-if="place == 'logo-default'"
    >
      <img
        src="/images/logo-medhop-transparent.png"
        width="150"
        class="my-2"
      />
    </div>
    <!-- end logo default medhop -->

    <!-- end print out section -->
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import ApiService from "@/core/services/api.service.js";
import { setConfiguration, getConfiguration } from "@/core/services/jwt.service.js";

export default {
  props: {
    height: Number,
    width: Number,
    place: String,
  },

  data() {
    return {
      // data
      primary: "/images/logo-medhop-transparent.png",
      data: getConfiguration() != null ? getConfiguration() : '',
      uploadingBrandLogo: false,

    };
  },
  methods: {
    useMedhopLogo(event) {
      event.target.src = "/images/logo-medhop-transparent.png"
    },
    async get() {
      this.data = await module.get("settings-no-auth/1");
    },

    openBrandLogoPicker() {
      if (!this.uploadingBrandLogo && this.$refs.brandLogoInput) {
        this.$refs.brandLogoInput.click();
      }
    },

    async uploadBrandLogo(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      if (!file) return;

      const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
      if (!allowedTypes.includes(file.type)) {
        this.showLogoUploadMessage("Format logo harus JPG, PNG, atau SVG.", "danger");
        input.value = "";
        return;
      }

      if (file.size > 4 * 1024 * 1024) {
        this.showLogoUploadMessage("Ukuran logo maksimal 4 MB.", "danger");
        input.value = "";
        return;
      }

      this.uploadingBrandLogo = true;
      try {
        await ApiService.put("settings/1", {
          company_name: this.data.company_name,
          clinic_name: this.data.clinic_name,
          brand_logo: file,
        });
        await this.getSetting();
        this.showLogoUploadMessage("Logo klinik berhasil diperbarui.", "success");
      } catch (error) {
        const response = error && error.response;
        const message = response && response.data && response.data.message
          ? response.data.message
          : "Logo belum berhasil diunggah. Silakan coba kembali.";
        this.showLogoUploadMessage(message, "danger");
      } finally {
        this.uploadingBrandLogo = false;
        input.value = "";
      }
    },

    showLogoUploadMessage(message, variant) {
      if (this.$bvToast) {
        this.$bvToast.toast(message, {
          title: variant === "success" ? "Berhasil" : "Gagal",
          variant,
          solid: true,
        });
      }
    },

    async getSetting() {
      let response = await module.get("settings-no-auth/1")
      if (response != null) {
        setConfiguration(JSON.stringify(response))
        this.data = response
      }
    },
  },
  computed: {
    brandLogo() {
      return (this.data && (this.data.brand_logo || this.data.logo)) || "/images/logo-medhop-transparent.png"
    },
    isDefaultBrandLogo() {
      const logo = String(this.brandLogo || "").toLowerCase();
      return !logo ||
        logo.includes("tenant/default/") ||
        logo.includes("/media/default/") ||
        logo.includes("/images/logo-medhop-transparent.png");
    },
    canEditConfiguration() {
      try {
        const access = JSON.parse(localStorage.getItem("access_right_display")) || [];
        return access.includes("2902") || access.includes(2902);
      } catch (error) {
        return false;
      }
    },
    canEditDefaultBrandLogo() {
      const configurationReady = Boolean(
        this.data && this.data.company_name && this.data.clinic_name
      );
      return this.place === "brand" && configurationReady &&
        this.isDefaultBrandLogo && this.canEditConfiguration;
    },
  },
  mounted() {
    if (this.data == '') {
      this.getSetting()
    }
    

    this.$root.$on("configurationEditSuccessfully", () => {
      this.get()
    });
  }
};
</script>

<style scoped>
.medhop-sidebar-logo__content {
  position: relative;
  display: inline-flex;
}

.medhop-sidebar-logo__edit {
  position: absolute;
  top: -7px;
  right: -13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  padding: 0;
  color: var(--skin-primary);
  background: #ffffff;
  border: 1px solid #d7e4ee;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(var(--skin-deep-rgb), 0.18);
  cursor: pointer;
  z-index: 2;
}

.medhop-sidebar-logo__edit:hover,
.medhop-sidebar-logo__edit:focus {
  color: #ffffff;
  background: var(--skin-secondary);
  border-color: var(--skin-secondary);
  outline: none;
}

.medhop-sidebar-logo__edit:disabled {
  cursor: wait;
  opacity: 0.72;
}

.medhop-sidebar-logo__edit i {
  margin: 0 !important;
  font-size: 0.68rem;
}

.medhop-sidebar-logo__input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}
</style>

<style lang="scss" scoped>
.medhop-sidebar-logo { min-width: 0; flex: 1; }
.medhop-sidebar-logo a { display: flex; min-width: 0; align-items: center; flex-direction: column; justify-content: center; text-decoration: none; }
.medhop-sidebar-logo img { display: block; width: auto; max-width: 132px; height: auto; max-height: 43px; object-fit: contain; }
.medhop-sidebar-logo small { margin-top: 2px; color: #7c8da2; font-size: 8px; font-weight: 600; letter-spacing: .02em; line-height: 1; }
</style>
